const tableCaption = {
    ' > div > svg': {
        color: '$icon',
        height: '$metadataHeaderIcon',
        marginRight: '$metadataHeaderIconMargin',
    },
    'alignItems': 'center',
    'display': 'flex',
    'fontSize': '$metadataHeaderText',
    'fontWeight': '$metadataHeaderText',
    'justifyContent': 'space-between',
    'marginBottom': '1rem',
    'overflowWrap': 'break-word',
    'textAlign': 'left',
    'whiteSpace': 'normal',
    'width': '100%',
}

const commonTableCell = {
    '& .blockKey': {
        display: 'block',
        fontWeight: 'bold',
    },
    '& .key': {fontWeight: 'bold'},
    '& .value': {whiteSpace: 'pre-wrap'},
    'paddingLeft': '20px',
    'verticalAlign': 'top',
    'width': '100%',
}

const commonLists = {
    '& ul.array': {
        listStyleType: '"- "',
        margin: 0,
        paddingLeft: '10px',
    },
    '& ul.icpc': {
        '& li': {
            '&:after': {content: ', '},
            '&:last-child:after': {content: ''},
            'display': 'inline',
        },
        'display': 'inline',
        'listStyle': 'none',
        'paddingLeft': 0,
    },
}

export const surveySummaryTableStyles = {
    '& table': {
        '& caption': tableCaption,
        '& tr': {
            '& td': commonTableCell,
            '&:first-of-type': {td: {paddingBottom: 0}},
        },
        ...commonLists,
        'borderSpacing': 0,
        'width': '100%',
    },
    'borderSpacing': 0,
    'padding': '$metadataPaddingVertical $metadataPaddingHorizontal',
}

export const captionTitle = {
    alignItems: 'center',
    display: 'flex',
}

export const cellInner = {
    '> div': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
    },
    'background': 'none',
    'border': 'none',
    'cursor': 'pointer',
    'fontSize': '15px',
    'padding': '0 0 5px 5px',
    'textAlign': 'left',
    'width': '100%',
}

export const copyButtonWrapper = {visibility: 'hidden'}
